import {Link, useLocation} from 'react-router-dom';

import "../css/navbar.css";

import React, {useState, useEffect} from "react";
import Logo from "../img/logo.png";
import apiUrl from '../globals';

const NavbarNew = () => {
    const location = useLocation();
    const [dolar, setDolar] = useState([]);

    const getDolar = async () => {
        try {
            const response = await fetch(apiUrl+'/get-dolar', {
                                        method: "GET",
                                        headers: {
                                            "Content-Type": "application/json",
                                            "Accept": "*/*",
                                        } 
                                    });                   
            const json = await response.json();
            console.log(json);
            setDolar(json);

        }catch(error){
            console.log(error);
        }
    }

    useEffect(() => {
        getDolar();
        
        // Inicializa tooltips do Bootstrap
        const initTooltips = () => {
            if (typeof window !== 'undefined' && window.bootstrap && window.bootstrap.Tooltip) {
                try {
                    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
                    tooltipTriggerList.forEach(tooltipTriggerEl => {
                        // Verifica se o elemento ainda está no DOM
                        if (!tooltipTriggerEl.isConnected) {
                            return;
                        }
                        
                        try {
                            const existing = window.bootstrap.Tooltip.getInstance(tooltipTriggerEl);
                            if (existing) {
                                // Atualiza a configuração do tooltip existente
                                existing._config.trigger = 'hover';
                                existing._config.delay = { show: 300, hide: 0 };
                            } else {
                                // Só cria se não existir, configurado para aparecer apenas no hover
                                new window.bootstrap.Tooltip(tooltipTriggerEl, {
                                    container: 'body',
                                    trigger: 'hover', // Apenas hover, sem focus nem click
                                    delay: { show: 300, hide: 0 }, // Sem delay para esconder
                                    boundary: 'viewport'
                                });
                            }
                        } catch (e) {
                            // Ignora erros de tooltips individuais
                            console.log('Erro ao inicializar tooltip:', e);
                        }
                    });
                } catch (e) {
                    // Ignora erros gerais
                    console.log('Erro ao buscar tooltips:', e);
                }
            }
        };
        
        // Aguarda um pouco para garantir que os elementos estão no DOM
        const timer = setTimeout(initTooltips, 300);
        
        return () => {
            clearTimeout(timer);
            // Limpa tooltips ao desmontar
            if (typeof window !== 'undefined' && window.bootstrap && window.bootstrap.Tooltip) {
                try {
                    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
                    tooltipTriggerList.forEach(tooltipTriggerEl => {
                        const existing = window.bootstrap.Tooltip.getInstance(tooltipTriggerEl);
                        if (existing) {
                            existing.dispose();
                        }
                    });
                } catch (e) {
                    // Ignora erros
                }
            }
        };
    }, []);

    // const [userName, setUserName] = useState('');

    const logout = () => {
        var Cookies = document.cookie.split(';');
         for (var i = 0; i < Cookies.length; i++){
            document.cookie = Cookies[i] + "=;expires=" + new Date(0).toUTCString();
         }
         window.location.href = "/";
    }

    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }   
    
    useEffect(() => {
        let cookie = getCookie('logged');
        if(typeof cookie !== "undefined"){
            cookie = JSON.parse(cookie);
            // setUserName(cookie.name);

            if(typeof cookie.resources !== "undefined"){
                for (let i = 0; i < cookie.resources.length; i++){
                    let resources = cookie.resources[i];
    
                    switch (resources.table) {
                        case "users":
                            if(!resources.read){
                                window.$("#usuariosBtn").css('display', 'none');
                            }
                        break;
    
                        case "permissions":
                            if(!resources.read){
                                window.$("#permissoesBtn").css('display', 'none');
                            }            
                        break;
    
                        case "verticals":
                            if(!resources.read){
                                window.$("#verticaisBtn").css('display', 'none');
                            }                  
                        break;
    
                        case "key_values":
                            if(!resources.read){
                                window.$("#keyvaluesBtn").css('display', 'none');
                            }                 
                        break;
    
                        case "google_ads":
                            if(!resources.read){
                                window.$("#googleadsBtn").css('display', 'none');
                            }                
                        break;
    
                        case "facebook":
                            if(!resources.read){
                                window.$("#facebookBtn").css('display', 'none');
                            }                   
                        break;
    
                        case "active":
                            if(!resources.read){
                                window.$("#activeBtn").css('display', 'none');
                            }                  
                        break;
    
                        default:
                            break;    
                    }            
                }            
            }
        }
    }, []);

    // Todos os itens do menu organizados com ícones
    const menuItens = [
        { text: "Home", route: "/home", icon: "home" },
        { text: "Usuários", route: "/usuarios", id: "usuariosBtn", icon: "group" },
        { text: "Permissões", route: "/permissions", id: "permissoesBtn", icon: "admin_panel_settings" },
        { text: "Verticais", route: "/verticais", id: "verticaisBtn", icon: "vertical_align_top" },
        { text: "Google Ads", route: "/google-ads", id: "googleadsBtn", icon: "ads_click" },
        { text: "CPA Blacklist", route: "/cpa-blacklist-config", id: "cpaBlacklistBtn", icon: "block" },
        { text: "Facebook", route: "/facebook", id: "facebookBtn", icon: "team_dashboard" },
        { text: "Key Values", route: "/key-values", id: "keyvaluesBtn", icon: "key" },
        { text: "UTM Sources", route: "/utm-sources", id: "utmSourcesBtn", icon: "swap_horiz" },
        { text: "Relatórios", route: "/relatorios", icon: "bar_chart" },
        { text: "GAM Status", route: "/gam-status", icon: "monitoring" },
        { text: "Minha conta", route: "/account", icon: "manage_accounts" },
        { text: "Logout", route: "#", onClick: logout, icon: "logout" }
    ];

    const handleItemClick = (e, item) => {
        if (item.onClick) {
            e.preventDefault();
            item.onClick();
        }
    };

    // Função isolada para verificar se um item do menu está ativo
    const isMenuItemActive = (itemRoute, currentPath) => {
        // Se a rota atual é exatamente igual à rota do item
        if (currentPath === itemRoute) {
            return true;
        }
        
        // Rotas que não devem ativar sub-rotas (rotas exatas)
        const exactRoutes = ['/home', '/account', '/gam-status'];
        if (exactRoutes.includes(itemRoute)) {
            return false;
        }
        
        // Para outras rotas, verifica se a rota atual começa com a rota do item + '/'
        // Exemplo: /relatorios/roi ativa o item /relatorios
        if (currentPath.startsWith(itemRoute + '/')) {
            return true;
        }
        
        return false;
    };

    return (
        <nav className="navbar navbar-dark bg-dark fixed-top" id="mainNavbar">
            <div className="container-fluid position-relative">
                <Link to="/home" className="navbar-brand"><img src={Logo} id="logoNavbar" alt="404 Dash Logo" /></Link>
                
                <div className="position-absolute start-50 translate-middle-x">
                    <ul className="navbar-nav flex-row align-items-center">
                        {menuItens.map((item, i) => {
                            // Verifica se o item está ativo usando a função isolada
                            const isActive = isMenuItemActive(item.route, location.pathname);
                            const activeClass = isActive ? 'nav-icon-link-active' : '';
                            
                            return (
                                <li key={i} className="nav-item me-5">
                                    {item.onClick ? (
                                    // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                    <a 
                                        className={`nav-link d-flex align-items-center justify-content-center nav-icon-link ${activeClass}`}
                                        href="#logout" 
                                        onClick={(e) => {
                                            // Esconde tooltip ao clicar
                                            const tooltip = window.bootstrap?.Tooltip?.getInstance(e.currentTarget);
                                            if (tooltip) {
                                                tooltip.hide();
                                            }
                                            handleItemClick(e, item);
                                        }}
                                        id={item.id}
                                        data-bs-toggle="tooltip"
                                        data-bs-trigger="hover"
                                        data-bs-placement="bottom"
                                        title={item.text}
                                        style={{padding: '0.5rem', width: '40px', height: '40px'}}
                                    >
                                            {item.icon && <span className="material-symbols-outlined" style={{fontSize: '24px'}}>{item.icon}</span>}
                                        </a>
                                    ) : (
                                        <Link 
                                            to={item.route} 
                                            className={`nav-link d-flex align-items-center justify-content-center nav-icon-link ${activeClass}`}
                                            id={item.id}
                                            data-bs-toggle="tooltip"
                                            data-bs-trigger="hover"
                                            data-bs-placement="bottom"
                                            title={item.text}
                                            onClick={(e) => {
                                                // Esconde tooltip ao clicar
                                                const tooltip = window.bootstrap?.Tooltip?.getInstance(e.currentTarget);
                                                if (tooltip) {
                                                    tooltip.hide();
                                                }
                                            }}
                                            style={{padding: '0.5rem', width: '40px', height: '40px'}}
                                        >
                                            {item.icon && <span className="material-symbols-outlined" style={{fontSize: '24px'}}>{item.icon}</span>}
                                        </Link>
                                    )}
                                </li>
                            );
                        })}
                    </ul>
                </div>

                <div className="d-flex align-items-center ms-auto">
                    <label className='text-secondary me-3 mb-0'>Cotação do dólar: <strong className='text-white'>R$ {dolar.dolarMinus20}</strong></label>
                    <button className="btn btn-sm changeThemeBtn" type="button" id="darkModeBtn" title="Apagar as luzes"><span className="material-symbols-outlined">dark_mode</span></button>
                    <button className="btn btn-sm changeThemeBtn" type="button" id="lightModeBtn" title="Acender as luzes"><span className="material-symbols-outlined">light_mode</span></button>
                </div>
            </div>
        </nav>
    );
}

export default NavbarNew;

